import React, { useState } from "react"
import { Collapse } from "react-bootstrap"

export default function DashboardTileSection({
  title,
  badgeCount = 0,
  alwaysOpen = false,
  children,
}) {
  const [forcedOpen, setForcedOpen] = useState(null)
  const autoOpen = alwaysOpen || badgeCount > 0
  const isOpen = alwaysOpen || (forcedOpen !== null ? forcedOpen : autoOpen)
  const sectionId = `dashboard-tile-section-${title.replace(/\s+/g, "-").toLowerCase()}`

  const handleToggle = () => {
    if (alwaysOpen) return
    setForcedOpen(!isOpen)
  }

  return (
    <div className="dashboard-tile-section mb-3">
      <button
        type="button"
        className="btn btn-link p-0 text-dark font-weight-bold text-decoration-none dashboard-tile-section__toggle"
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-controls={sectionId}
        disabled={alwaysOpen}
      >
        {!alwaysOpen && (
          <span className={`mr-1 ${isOpen ? "" : "text-muted"}`}>
            {isOpen ? "▼" : "▶"}
          </span>
        )}
        <span className="dashboard-tile-section__title">{title.toUpperCase()}</span>
        {!alwaysOpen && badgeCount > 0 && (
          <span className="badge badge-pill badge-danger ml-2 dashboard-tile-section__badge">
            {badgeCount}
          </span>
        )}
      </button>
      <Collapse in={isOpen}>
        <div id={sectionId}>
          <div className="row key-to-do">
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  )
}
